<script setup>
import {defineProps, defineEmits} from "vue";

defineProps({
    show: Boolean,
    loading: Boolean,
    disabled: Boolean,
    error: Boolean,
    block: Boolean,
})

const emit = defineEmits(["press"]);

function press() {
    emit('press');
}
</script>

<template>
    <w-btn
        color="blue darken-2"
        :loading="loading"
        :text="$t('common.reload')"
        icon="mdi-reload"
        @press="press"
    />
</template>

<style scoped>

</style>